import React from 'react';
import { useTranslation } from 'react-i18next';

const ImageFormatTable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto mb-32">
      <h2>{t('formats.title')}</h2>
      <p className="mb-12 max-w-4xl">{t('formats.description')}</p>
      <div className="overflow-x-auto bg-gray-200 rounded-card">
        <table className="min-w-full">
          <thead className="bg-gray-300 border-b border-gray-500">
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-800">{t('formats.headers.format')}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-800">{t('formats.headers.bestFor')}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-800">{t('formats.headers.transparency')}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-800">{t('formats.headers.compression')}</th>
              <th className="px-6 py-4 text-left text-sm font-semibold text-gray-800">{t('formats.headers.qualityLoss')}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-400">
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">JPEG</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.jpeg.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.jpeg.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.jpeg.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.jpeg.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">PNG</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.png.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.png.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.png.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.png.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">BMP</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.bmp.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.bmp.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.bmp.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.bmp.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">ICO</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.ico.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.ico.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.ico.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.ico.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">WebP</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.webp.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.webp.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.webp.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.webp.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">AVIF</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.avif.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.avif.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.avif.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.avif.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">GIF</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.gif.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.gif.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.gif.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.gif.qualityLoss')}</td>
            </tr>
            <tr className="hover:bg-gray-200">
              <td className="px-6 py-4 text-sm text-gray-800 font-medium">SVG</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.svg.bestFor')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.svg.transparency')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.svg.compression')}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{t('formats.svg.qualityLoss')}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ImageFormatTable;